import { getCookie } from 'cookies-next';
import { useLocale } from 'next-intl';
import { getSelectedLanguage } from '../helpers/getSelectedLanguage';
function useIntl() {
  const lngCookie = getCookie("lng") as string;
  const locale = useLocale();
  return getSelectedLanguage({
    lngCookie,
    locale
  });
}
export default useIntl;